/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, Image, TouchableOpacity, TouchableWithoutFeedback, StyleSheet } from 'react-native'
import styles from './Styles/ImageAndTextStyle'
import TextComponent from './TextComponent'
import {Images} from '../Themes/'

export default class ImageAndText extends Component {
  constructor(props) {
    super(props)
    const { extraTextStyle = {} } = this.props
    if (Array.isArray(extraTextStyle))
      this.textStyle = Object.assign({},
        StyleSheet.flatten(styles.text),
        {color: 'rgb(119, 119, 119)', fontSize: 15, width: 35},
        ...extraTextStyle)
    else
      this.textStyle = Object.assign({},
        StyleSheet.flatten(styles.text),
        {color: 'rgb(119, 119, 119)', fontSize: 15, width: 35},
        extraTextStyle)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true
    let changed = false
    if (this.props.text !== nextProps.text)
      changed = true
    return changed
  }

  render() {
    // const { extraTextStyle = {} } = this.props
    //console.log("extra text style = " + JSON.stringify(extraTextStyle))
    // {this.props.isText && <TextComponent text={this.props.text} style ={[this.defaultTextStyle, extraTextStyle]}/>}
    // TouchableWithoutFeedback
    // const children = !source ? this.props.children : (
    //  <Image source={source} style={imageStyle}/>
    // )
    const { source = null, imageStyle = {} } = this.props
    return (
      <TouchableOpacity onPress={this.props.onPress} disabled={!this.props.onPress} style={styles.button}>
        <View>
          <Image source={source} style={imageStyle}/>
        </View>
        {this.props.isText && <Text style={this.textStyle}>{this.props.text}</Text>}
      </TouchableOpacity>
    )
  }
}
